var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple25(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5318 8.75849C22.4195 8.82885 19.7442 10.3136 19.7442 13.6055C19.8703 17.3597 23.1202 18.6763 23.176 18.6763C23.1202 18.7467 22.6853 20.4698 21.3971 22.2762C20.3747 23.8321 19.2399 25.4009 17.5167 25.4009C15.8776 25.4009 15.2892 24.3639 13.3979 24.3639C11.3669 24.3639 10.7922 25.4009 9.23711 25.4009C7.51394 25.4009 6.29511 23.7481 5.21699 22.2067C3.81634 20.1893 2.62583 17.0235 2.58381 13.9837C2.55548 12.3729 2.8643 10.7896 3.64822 9.44466C4.75467 7.56708 6.73001 6.29251 8.88717 6.25049C10.54 6.19475 12.011 7.38526 13.0197 7.38526C13.9863 7.38526 15.7936 6.25049 17.8383 6.25049C18.7209 6.2514 21.0745 6.51728 22.5318 8.75849ZM12.8799 5.92888C12.5857 4.45788 13.3979 2.98688 14.1544 2.04854C15.1211 0.913774 16.6478 0.143555 17.9644 0.143555C18.0485 1.61455 17.5158 3.05723 16.5638 4.10794C15.7095 5.24271 14.2385 6.09699 12.8799 5.92888Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple25);
export default __webpack_public_path__ + "static/media/apple_25.cabd46bd1484a6ed8b42d2fc165c547d.svg";
export { ForwardRef as ReactComponent };